import { ReactElement } from "react";
import { maxLength, minLength, required } from "react-admin";

import { LOCALES } from "../../../constants";
import UseLocalizedRAInputs from "../../../hooks/useLocalizedRAInputs";
import { Limitations } from "../../../types/limitations.types";

export const useBrandsLocalizations = (props: any): ReactElement<any, any>[] | null => {
  return UseLocalizedRAInputs([
    {
      key: "displayName",
      label: "Display Name",
      variant: "outlined",
      validate: {
        [LOCALES[0].key]: [
          required(),
          minLength(Limitations.BrandsMinNameLength),
          maxLength(Limitations.BrandsMaxNameLength),
        ],
        [LOCALES[1].key]: [
          required(),
          minLength(Limitations.BrandsMinNameLength),
          maxLength(Limitations.BrandsMaxNameLength),
        ],
      },
      counter: Limitations.BrandsMaxNameLength,
      ...props,
    },
  ]);
};

export default useBrandsLocalizations;
